import Vue from 'vue';

const VUE_APP_AUTH_BASE_URL = process.env.VUE_APP_AUTH_BASE_URL;

const isLocal = process.env.VUE_APP_ENV === 'local';

export const loginUserRequest = (payload) => {
  return Vue.axios.post(`${VUE_APP_AUTH_BASE_URL}/authorization`, {
    ...payload,
    ...(isLocal && { returnTokens: true }),
  });
};

export const optCheckRequest = (payload) => {
  return Vue.axios.post(`${VUE_APP_AUTH_BASE_URL}/authorization/otp-check`, {
    ...payload,
    ...(isLocal && { returnTokens: true }),
  });
};
